<div class="card shadow mb-5 bg-white rounded">
    <div class="card-body">
        <div class="Placeholder-img-container d-flex justify-content-center">
            <img class="placeholder-img" src="{{assetUrl}}/assets/competitor_placeholder.png"/>
        </div>
        <div class="placeholder-text d-flex justify-content-center">Select up to 4 competitors</div>
    </div>
</div>